import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function PushToTalkToggle() {
  const { t } = useTranslation();
  const usePushToTalk = SettingsStore(state => state.usePushToTalk);
  const setUsePushToTalk = SettingsStore(state => state.setUsePushToTalk);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="push-to-talk">{t("settings.usePushToTalk")}</Label>
        <Switch
          id="push-to-talk"
          checked={usePushToTalk}
          onCheckedChange={setUsePushToTalk}
          disabled={isLoading}
        />
      </div>
    </ControlWrapper>
  );
}
